import { Layout } from 'antd';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { Path } from '@/enums';

const { Content } = Layout;

export const ProfileLayout = () => {
  const { token } = useAuth();

  if (!token) {
    return <Navigate to={Path.Login} replace />;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
};
